import React from "react";
import { useTranslation } from "react-i18next";
import aerialmenubg from "../../Assets/ServiceImg/aerial-bg.webp"; // Imagen de fondo de las preguntas
import Contact from "../Home/Contact";
import ServiceInfo from "./ServiceInfo";
import Services from "../About/Services";
import AboutCardHome from "../About/AboutCardHome";
import { Helmet } from "react-helmet-async";
import Seoimg from "../../Assets/ServiceImg/aerial-bg.webp";
import { useLocation } from "react-router-dom";

const AerialPhotography = () => {
   const { t } = useTranslation();

      const location = useLocation();
      const selectedLanguage = location.pathname.startsWith("/en")
         ? "en"
         : "es";
   
   const seoTranslations = {
      es: {
         title: "Servicios Audiovisuales con Drones para Empresas en Mallorca | Joan Company",
         description:
            "Contenido aéreo profesional para inmobiliarias, concesionarios, marcas y productoras de eventos en Mallorca. Paquetes flexibles, colaboración recurrente.",
         keywords:
            "servicios drones Mallorca, fotografía aérea inmobiliaria, vídeo aéreo profesional, drones para eventos, inspecciones técnicas drones, drones fpv, operador drones certificado",
         canonical: "https://www.joancompany.es/servicios-drones",
         descriptionOG:
            "¿Necesitas tomas únicas? Ofrezco servicios de drones de alta resolución para el sector inmobiliario, técnico y eventos.",
      },
      en: {
         title: "Audiovisual Services with Drones in Mallorca | Joan Company",
         description:
            "Professional aerial content for real estate, dealerships, brands and event production in Mallorca. Flexible packages, recurring collaboration.",
         keywords:
            "drone services Mallorca, aerial photography real estate, professional aerial video, drones for events, technical inspections drones, fpv drones, certified drone operator",
         canonical: "https://www.joancompany.es/en/servicios-drones",
         descriptionOG:
            "Need unique shots? I offer high-resolution drone services for the real estate, technical and event sectors.",
      },
   };

   return (
      <div className="service-container" id="services-page">
         <Helmet>
            <title key="title">{seoTranslations[selectedLanguage].title}</title>
            <meta
               key="description"
               name="description"
               content={seoTranslations[selectedLanguage].description}
            />
            <meta
               key="keywords"
               name="keywords"
               content={seoTranslations[selectedLanguage].keywords}
            />
            <link
               rel="canonical"
               href={seoTranslations[selectedLanguage].canonical}
            />
            <meta property="og:image" content={Seoimg} />
            <meta
               property="og:title"
               content={seoTranslations[selectedLanguage].title}
            />
            <meta
               property="og:description"
               content={seoTranslations[selectedLanguage].descriptionOG}
            />
            <link rel="image_src" href={Seoimg} />
            <link
               rel="alternate"
               href="https://www.joancompany.es/servicios-drones"
               hreflang="es"
            />
            <link
               rel="alternate"
               href="https://www.joancompany.es/en/servicios-drones"
               hreflang="en"
            />
            <html lang={selectedLanguage} />
         </Helmet>
         <ServiceInfo
            title={t("services_withdrones")}
            image={aerialmenubg}
            subtitle={`${t("services_desc")} ${t("services_desc_strong")}`}
            description={`${t("services_desc")} ${t("services_desc_strong")}`}
         />
         <div className="skill-section-container-page" id="skills">
            <Services showHeader={false} />
         </div>
         <AboutCardHome />
         <Contact />
      </div>
   );
};

export default AerialPhotography;
